import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, firstValueFrom, lastValueFrom, skip, take } from 'rxjs';
import { Customer, CustomerAuth } from '../../shared/models/Customer';
import { UserApiService } from './user-api.service';
import { Address } from '../../shared/classes/Address';

@Injectable({
	providedIn: 'root',
})
export class UserStateService {
	get customer(): Customer {
		return this.customerAuth$.value.customer;
	}

	userInitialized() {
		return firstValueFrom(this.customerAuth$.pipe(filter(Boolean)));
	}

	address$ = new BehaviorSubject<Address>(null);
	deliveryAddress$ = new BehaviorSubject<Address>(null);
	customerAuth$: BehaviorSubject<CustomerAuth> = new BehaviorSubject<CustomerAuth>(null);

	private userApiSvc = inject(UserApiService);
	constructor() {
		const customerAuthFromStorage: CustomerAuth | null = JSON.parse(localStorage.getItem('customer-auth'));
		this.customerAuth$.next(customerAuthFromStorage);
		this.customerAuth$.subscribe(async res => {
			if (!res) {
				const res = await lastValueFrom(this.userApiSvc.signInAnonymous()).catch(err => {
					localStorage.setItem('customer-auth', 'null');
				});
				if (res) this.customerAuth$.next(res);
				return;
			}

			localStorage.setItem('customer-auth', JSON.stringify(res));
			// if (this._order) {
			// 	this._order.userUid = this._customerAuth.customer.uid;
			// 	this.order.emit(this._order);
			// }
		});
	}
}
